import { LOCALE } from '@foxrenderfarm/internals'
import { baseTaskUrl } from './env'

export const getRegisterLink = (locale?: LOCALE, search = '') => {
  const baseRegisterLink = `${baseTaskUrl()}/sso/signup`
  let link = baseRegisterLink
  if (search && search.startsWith('?')) {
    link = `${link}${link.includes('?') ? '&' : '?'}${search.substring(1)}`
  }
  return link
}
